import React from 'react';

import Subheader from 'material-ui/Subheader';
import {List, ListItem} from 'material-ui/List';
import Divider from 'material-ui/Divider';
import ActionWork from 'material-ui/svg-icons/action/work';

const h2Icon = {
  marginLeft: 24,
  marginRight: 24,
};

let page = (props) => (
  <div>
    <h2><ActionWork style={h2Icon} />Work Experience</h2>
    <p>Over ten years of industry experience as a software practitioner, primarily in web applications, and an additional ten years of academic experience as a lecturer in higher education.</p>
    <p>Taught and supervised across first-, second-, and most recently third-cycle programs in software engineering and information technologies.</p>
    <List>
      <Divider inset={true} />
      <Subheader inset={true}>Academia</Subheader>
      <ListItem
        primaryText="Associate Professor, Kristiania University College"
        secondaryText={<span>Olso, Norway — 2022-current<br /></span>}
        disabled="true"
        insetChildren="true"
      />
      <ListItem
        primaryText="Postdoctoral Fellow, Simula Metropolitan Centre for Digital Engineering"
        secondaryText={<span>Olso, Norway — 2019-2022<br /></span>}
        disabled="true"
        insetChildren="true"
      />
      <ListItem
        primaryText="Doctoral Candidate / PhD Student, BTH - Blekinge Tekniska Högskola"
        secondaryText={<span>Kalskrona, Blekinge, Sweden — 2014-2019<br /></span>}
        disabled="true"
        insetChildren="true"
      />
      <ListItem
        primaryText="Associate Lecturer, UNIVALI - Universidade do Vale do Itajaí"
        secondaryText={<span>Itajaí, SC, Brazil — 2010-2014<br /></span>}
        disabled="true"
        insetChildren="true"
      />
      <Divider inset={true} />
      <Subheader inset={true}>Industry</Subheader>
      <ListItem
        primaryText="Project Manager, ENOVA Interactive"
        secondaryText={<span>Itajai, SC, Brazil — 2006-2014<br />Web applications and client-server applications.</span>}
        disabled="true"
        insetChildren="true"
      />
      <ListItem
        primaryText="Web Designer, GRUPOW"
        secondaryText={<span>Balneario Camboriu, SC, Brazil — 2003-2005<br />Web sites and web applications.</span>}
        disabled="true"
        insetChildren="true"
      />
    </List>
  </div>
);

export default page;



// WEBPACK FOOTER //
// ./src/components/Home/WorkExperience.js